import { render, staticRenderFns } from "./jh.vue?vue&type=template&id=26cfc6c8&scoped=true&"
import script from "./jh.vue?vue&type=script&lang=js&"
export * from "./jh.vue?vue&type=script&lang=js&"
import style0 from "./jh.vue?vue&type=style&index=0&id=26cfc6c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cfc6c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
